import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import cardsBg from "assets/images/common/others/cardsBg.png";
import cardProfilePic from "assets/images/common/others/cardProfilePic.png";
import { ReactComponent as ReviewIcon } from "assets/images/common/svgs/reviewGolden.svg";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import DataNotFound from "components/particles/table/data-not-found";



interface Props {
  attendeeId: number;
}
const FavoriteHost = ({ attendeeId }: Props) => {
  const { getFavoriteHostById } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    getFavoriteHostById(
      { attendeeId: attendeeId, page: 0, size: 50 },
      setData
    );
  }, []);

  console.log(data);
  return (
    <div>
      <div className="flex flex-wrap items-center gap-4 py-5">
        {data.map((item: any, index: number) => (
          <div

            key={index}
            className="flex flex-col items-center justify-center p-4  min-w-[235px] min-h-[259px] cursor-pointer bg-cover bg-center bg-no-repeat rounded-3xl"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[100px] h-[100px] object-cover rounded-full"
                src={
                  item?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      item?.profilePicUrl?.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt={item?.firstName}
              />
            </div>
            <span className="text-base font-semibold my-2 text-primaryText">
              {item?.firstName} {item?.lastName}
            </span>
            <div className="flex justify-center gap-2">
              <span className="">
                <ReviewIcon />
              </span>
              <span className="text-sm  text-primaryText">(5.0)</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 text-9xl">
        <DataNotFound show={!isLoading && !data.length} />
      </div>
    </div>
  );
};

export default FavoriteHost;
